import { PageCondition } from '@/features/analyze/types';
import { atom, useAtom, useAtomValue, useSetAtom } from 'jotai';
import { atomWithHash } from 'jotai-location';

const pageConditionAtom = atom<PageCondition>((get) => {
  const perPage = get(perPageAtom);
  const offset = get(pageOffsetAtom);

  return { perPage, offset };
});

const perPageAtom = atomWithHash<number | undefined>('perPage', undefined);
const pageOffsetAtom = atomWithHash<number>('pageOffset', 0);

export const usePageConditionAtomValue = () => useAtomValue(pageConditionAtom);

export const usePerPageConditionAtom = () => useAtom(perPageAtom);
export const useSetPageOffsetAtom = () => useSetAtom(pageOffsetAtom);
